import { render } from "./RoleGroupManagementView.vue?vue&type=template&id=17a79193&scoped=true"
import script from "./RoleGroupManagementView.vue?vue&type=script&lang=js"
export * from "./RoleGroupManagementView.vue?vue&type=script&lang=js"

import "./RoleGroupManagementView.vue?vue&type=style&index=0&id=17a79193&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a79193"]])

export default __exports__